<div class="activity-details solo">
    <c-auto-form config="setCurrentStage.autoFormConfig"></c-auto-form>
    <c-auto-form ng-repeat="easyFlowAutoForm in setCurrentStage.easyFlowAutoForms | orderBy:'index'" config="easyFlowAutoForm" ng-show="setCurrentStage.activity.configureEasyFlow"></c-auto-form>
</div>